import React, { useState, useEffect } from 'react';
import { Card, Modal, Row, Col, Spin, Input, Form, Icon, Button, Radio, Checkbox } from 'antd';
import Editor from 'components/Form/WYSIWYG';

import { connect } from 'react-redux';
import { browserHistory, Link } from 'react-router';
import cn from 'classnames';
import callApi from 'helpers/callApi';
import moment from 'moment';

import { formItemLayout } from 'constants/layout';
import { editTeacher, getTeacherById } from 'data/teacher';
import { isEmpty, remove, find } from 'lodash';
import { MultipleDatePickerCalendar } from 'components';

import styles from '../styles/teacher/TeacherCalendar.module.scss';

const FormItem = Form.Item;
const RadioGroup = Radio.Group;
const { TextArea } = Input;

const formatMultipleDate = 'DD/MM/YYYY';

const TEXT = 'LABELS.editTimetable';
const OPENCLASSTYPES = [
  { value: false, label: 'สอนได้ 1 คลาส ในช่วงเวลาหนึ่งๆ', remark: '* สอนได้ 1 คลาสในช่วงเวลาหนึ่งๆ หมายถึง ผู้สอนสามารถเปิดสอนได้เพียงคลาสเดียวในช่วงเวลาที่กำหนด' },
  { value: true, label: 'สอนได้หลายคลาสพร้อมกัน', remark: '* สอนได้หลายคลาสพร้อมกัน หมายถึง ผู้สอน/สตูดิโอนั้นๆ มีหลายคลาส และแต่ละคลาสสามารถเปิดสอนในวัน เวลาเดียวกันได้' },
];

const checkboxsRows = [
  [
    { label: 'เลือกทุกวันจันทร์', value: [8], field: 'monday' },
    { label: 'เลือกทุกวันเสาร์', value: [6], field: 'saturday' },
  ],
  [
    { label: 'เลือกทุกวันอังคาร', value: [2], field: 'tuesday' },
    { label: 'เลือกทุกวันอาทิตย์', value: [7], field: 'sunday' },
  ],

  [{ label: 'เลือกทุกวันพุธ', value: [3], field: 'wednesday' }],
  [{ label: 'เลือกทุกวันพฤหัส', value: [4], field: 'thursday' }],
  [{ label: 'เลือกทุกวันศุกร์', value: [5], field: 'friday' }],
];

const TeacherCalendar = ({ teacher }) => {
  const [loading, setLoading] = useState(false);
  const [month, setMonth] = useState(moment());

  const [selectedCheckboxs, setSelectedCheckboxs] = useState({
    sunday: false,
    monday: false,
    tuesday: false,
    wednesday: false,
    thursday: false,
    friday: false,
    saturday: false,
    weekend: false,
    weekdays: false,
    everydayInMonth: false,
  });
  const [openScheduleDates, setOpenScheduleDates] = useState([]);
  const [openClassType, setOpenClassType] = useState(teacher.isMultipleClassOpenAtSameTime);
  const [selectedDays, setSelectedDays] = useState([]);
  const [initSelectedDays, setInitSelectedDays] = useState([]);
  const [me, setMe] = useState(teacher);
  const [errors, setErrors] = useState({});
  const maxDay = moment().add(6, 'months').startOf('days');

  const fetchOpenSchedules = async () => {
    const schedules = await callApi({ url: '/teachers/me/schedules' });
    const _openSchedules = schedules.map((obj) => {
      return moment(obj.start).startOf('day').toDate().toLocaleDateString('en-US');
    });
    setOpenScheduleDates(_openSchedules);
  };

  const fetchCalendar = async () => {
    const calendar = await callApi({ url: `/teachers/${teacher._id}/calendars` });
    if (calendar) {
      const _selectedDays = calendar.reduce((results, calendar) => {
        if (!calendar.isClosed) {
          const date = moment(calendar.date); //.tz('Asia/Bangkok');
          results.push(date.toDate());
        }
        return results;
      }, []);
      setSelectedDays(_selectedDays);
      setInitSelectedDays([..._selectedDays]);
    }
  };
  useEffect(() => {
    window.scrollTo(0, 0);
    fetchOpenSchedules();
    fetchCalendar();
  }, []);

  if (!me) {
    return <div></div>;
  }

  // const refreshTeacherProfile = async () => {
  //   const _teacherInfo = await getMyTeacherProfile();
  //   setMe(_teacherInfo);
  // };

  // if (query.type === 'fb') {
  //   Router.push('/');
  // }

  // const handleCheckboxChange = (data) => {
  //   setSelectedCheckboxs({
  //     ...selectedCheckboxs,
  //     [data.name]: data.value,
  //   });
  // };

  const validateEverydayInMonthSelected = (value, nextStateMonth) => {
    let isEverydaySelect = true;
    const today = moment();
    const startOfMonth = nextStateMonth ? nextStateMonth.startOf('month') : month.startOf('month');
    const _month = startOfMonth.month();
    let dateToAdd = moment(startOfMonth); //.add(i, 'week');
    while (_month === dateToAdd.month() && !dateToAdd.isAfter(maxDay)) {
      if (!dateToAdd.isBefore(today)) {
        const foundDate = find(value, (day) => {
          return day.toLocaleDateString('en-US') === dateToAdd.toDate().toLocaleDateString('en-US');
        });

        if (!foundDate) {
          isEverydaySelect = false;
        }
      }
      dateToAdd = dateToAdd.add(1, 'day');
      // console.log(dateToAdd.format('LLLL'));
    }
    return isEverydaySelect;
  };

  const onMultipleDateChange = (value) => {
    setSelectedCheckboxs({
      ...selectedCheckboxs,
      everydayInMonth: validateEverydayInMonthSelected(value),
    });
  };

  // const validate = () => {
  //   const _errors = {};

  //   if (!user.firstName) {
  //     _errors.firstName = 'จำเป็นต้องกรอก';
  //   }

  //   setErrors(_errors);
  //   console.log(_errors);
  //   return isEmpty(_errors);
  // };

  const updateData = async () => {
    try {
      setLoading(true);
      const _initSelectedDays = initSelectedDays.map((day) => {
        return { date: moment(day).format('DD-MM-YYYY') };
      });
      const currentSelectedDays = selectedDays.map((day) => {
        return { date: moment(day).format('DD-MM-YYYY') };
      });

      const closedDates = _initSelectedDays.reduce((results, day) => {
        if (!find(currentSelectedDays, day)) {
          results.push({ ...day, isClosed: true });
        }
        return results;
      }, []);

      const data = {
        calendars: currentSelectedDays.concat(closedDates),
        isMultipleClassOpenAtSameTime: openClassType,
      };

      await callApi({ url: `/teachers/${teacher._id}/calendars`, method: 'put', body: data });

      setLoading(false);
      // window.location.href = '/teachers/me';
    } catch (err) {
      setLoading(false);
    }

    return false;
  };
  const cancel = async () => {
    // Router.back();
  };

  const clearCalendarThisMonth = () => {
    const _month = month.get('month');
    const newSelectedDays = selectedDays.reduce((results, selectedDay) => {
      if (_month !== moment(selectedDay).month()) {
        results.push(selectedDay);
      }
      return results;
    }, []);
    setSelectedDays(newSelectedDays);
    setSelectedCheckboxs({
      ...selectedCheckboxs,
      everydayInMonth: false,
    });
  };

  const selectDaysOfWeek = (days = [], checkboxStatus) => {
    // monday use 8
    const today = moment();

    // formatMultipleDate
    // console.log(month.);

    days.forEach((day) => {
      // let firstDayOfWeek = moment().year(month.get('year')).month(month.get('month')).date(1).day(day).startOf('day');

      let firstDayOfWeek = moment().add(1, 'days').date(1).day(day).startOf('days');

      if (firstDayOfWeek.date() > 15) {
        firstDayOfWeek.add(1, 'week');
      }
      if (firstDayOfWeek.date() > 7) firstDayOfWeek.day(-6);

      let dateToAdd = moment(firstDayOfWeek); //.add(i, 'week');
      while (!dateToAdd.isAfter(maxDay)) {
        if (!dateToAdd.isBefore(today)) {
          if (checkboxStatus) {
            selectedDays.push(dateToAdd.toDate());
          } else {
            remove(selectedDays, (day) => {
              return day.toLocaleDateString('en-US') === dateToAdd.toDate().toLocaleDateString('en-US');
            });
            // console.log(selectedDays);
          }
        }
        dateToAdd = dateToAdd.add(1, 'week');
        // console.log(dateToAdd.format('LLLL'));
      }
    });

    setSelectedDays(selectedDays);
    return selectedDays;
  };

  const selectEverydayInMonth = (checkboxStatus) => {
    // monday use 8
    const today = moment();
    // formatMultipleDate
    const startOfMonth = month.startOf('month');
    const _month = startOfMonth.month();

    let dateToAdd = moment(startOfMonth); //.add(i, 'week');
    while (_month === dateToAdd.month() && !dateToAdd.isAfter(maxDay)) {
      if (!dateToAdd.isBefore(today)) {
        if (checkboxStatus) {
          selectedDays.push(dateToAdd.toDate());
        } else {
          // console.log(selectedDays.indexOf(dateToAdd.toDate()));
          remove(selectedDays, (day) => {
            return day.toLocaleDateString('en-US') === dateToAdd.toDate().toLocaleDateString('en-US');
          });
          // console.log(selectedDays);
        }
      }
      dateToAdd = dateToAdd.add(1, 'day');
      // console.log(dateToAdd.format('LLLL'));
    }

    setSelectedDays(selectedDays);
  };

  const onMonthChange = (_month) => {
    setMonth(moment(_month));
    setSelectedCheckboxs({
      ...selectedCheckboxs,
      everydayInMonth: validateEverydayInMonthSelected(selectedDays, moment(_month)),
    });
  };

  const modifiers = {
    'has-schedule': (day) => {
      return openScheduleDates.indexOf(day.toLocaleDateString('en-US')) > -1;
      // openScheduleDates
    },
  };

  const renderForm = () => {
    const isVerified = me.verifyStatus === 'verified';
    return (
      <div>
        <div>
          <div className={cn('form-group', { 'has-error': errors.skill })} style={{ marginTop: 15 }}>
            <Row>
              <Col sm={6}>
                <div className="text-right " style={{ marginRight: 6 }}>
                  ชนิดคลาสที่เปิดสอน: {openClassType}
                </div>
              </Col>

              <Col sm={18}>
                <RadioGroup
                  value={openClassType}
                  onChange={(e) => {
                    setOpenClassType(e.target.value);
                  }}
                >
                  {OPENCLASSTYPES.map((OPENCLASSTYPE) => (
                    <Radio value={OPENCLASSTYPE.value} className={cn('custom-radio')}>
                      {OPENCLASSTYPE.label}
                    </Radio>
                  ))}
                </RadioGroup>
              </Col>
            </Row>
          </div>
          <br />

          <div className={cn('form-group')} style={{ marginTop: 15 }}>
            <Row>
              <Col sm={6}>
                <div className="text-right " style={{ marginRight: 6 }}>
                  <div>วันที่เปิดสอน:</div>
                </div>
              </Col>
              <Col xs={12} span={12}>
                {' '}
                <div className={styles.multipleForm}>
                  <div>
                    <div className={styles.studyingDate}>
                      <div className={cn('form-group', { 'has-error': errors.date })}>
                        <div className={cn(styles.inputTitle, 'control-label')}> </div>

                        <MultipleDatePickerCalendar
                          onChange={(event) => onMultipleDateChange(event)}
                          onMonthChange={onMonthChange}
                          minDate={moment().add(1, 'days').startOf('days')}
                          maxDate={maxDay}
                          selectedDays={selectedDays}
                          modifiers={modifiers}
                        />

                        <div className={styles.calendarLegend}>
                          <div className={styles.center}>
                            <div style={{ marginLeft: 15 }}>
                              <span style={{ borderRadius: '50%', border: '2px solid #ff7700', width: 30, height: 30, display: 'inline-block' }}></span>
                              <span style={{ lineHeight: '30px', verticalAlign: 8, marginLeft: 10 }}>วันที่สามารถสอนได้</span>
                            </div>
                            {/* <div style={{ marginTop: 5, marginLeft: 15 }}>
                              <span style={{ borderRadius: '50%', border: '2px solid #ff7700', width: 30, height: 30, display: 'inline-block' }}></span>
                              <span style={{ lineHeight: '30px', verticalAlign: 8, marginLeft: 10 }}>วันที่สามารถสอนได้</span>
                            </div> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
          <br />
          <Row>
            <Col xs={6}></Col>
            <Col xs={9} style={{ paddingLeft: 15 }}>
              <div>
                <Checkbox
                  defaultChecked={false}
                  onChange={(value) => {
                    selectEverydayInMonth(value);
                    setSelectedCheckboxs({
                      ...selectedCheckboxs,
                      everydayInMonth: value,
                    });
                  }}
                  value={selectedCheckboxs.everydayInMonth}
                >
                  <span style={{ fontWeight: 400 }}>&nbsp;เลือกทุกวันในเดือนนี้</span>
                </Checkbox>
              </div>
            </Col>
            <Col xs={9}>
              <div className=" font-normal"></div>
            </Col>
          </Row>

          <hr />

          <Row>
            <Col xs={6}></Col>
            <Col xs={9} style={{ paddingLeft: 15 }}>
              กำหนดวันสำหรับ 6 เดือนล่วงหน้า
            </Col>
            <Col xs={9}>
              <div className=" font-normal">
                <div style={{ textDecoration: 'underline' }} className="pointer" onClick={clearCalendarThisMonth}>
                  ลบทั้งหมดในเดือนนี้
                </div>
              </div>
            </Col>
          </Row>
          <Row style={{ marginTop: 10 }}>
            <Col xs={6}></Col>

            <Col xs={9}>
              <div className=" font-normal">
                <Checkbox
                  defaultChecked={false}
                  onChange={(value) => {
                    const _selectedDays = selectDaysOfWeek([5, 4, 3, 2, 8], value);
                    setSelectedCheckboxs({
                      ...selectedCheckboxs,
                      weekdays: value,
                      everydayInMonth: validateEverydayInMonthSelected(_selectedDays),
                    });
                  }}
                  value={selectedCheckboxs.weekdays}
                >
                  <span style={{ fontWeight: 400 }}>&nbsp;เลือกทุกวันธรรมดา</span>
                </Checkbox>
              </div>
            </Col>
            <Col xs={9} style={{ paddingLeft: 15 }}>
              <div className=" font-normal">
                <Checkbox
                  defaultChecked={false}
                  onChange={(value) => {
                    const _selectedDays = selectDaysOfWeek([6, 7], value);
                    setSelectedCheckboxs({
                      ...selectedCheckboxs,
                      weekend: value,
                      everydayInMonth: validateEverydayInMonthSelected(_selectedDays),
                    });
                  }}
                  value={selectedCheckboxs.weekend}
                >
                  <span style={{ fontWeight: 400 }}>&nbsp;เลือกทุกวันเสาร์-อาทิตย์</span>
                </Checkbox>
              </div>
            </Col>
          </Row>
          {checkboxsRows.map((checkboxs) => (
            <div className={cn('form-group', styles.checkboxRow)}>
              <Row style={{ marginTop: 10 }}>
                <Col xs={6}></Col>
                <Col xs={18}>
                  <Row>
                    {checkboxs.map((_checkbox, i) => (
                      <Col xs={12} style={{ paddingLeft: i % 2 === 0 ? 15 : 0 }}>
                        <Checkbox
                          defaultChecked={false}
                          onChange={(value) => {
                            const _selectedDays = selectDaysOfWeek(_checkbox.value, value);
                            setSelectedCheckboxs({
                              ...selectedCheckboxs,
                              [_checkbox.field]: value,
                              everydayInMonth: validateEverydayInMonthSelected(_selectedDays),
                            });
                          }}
                          value={selectedCheckboxs[_checkbox.field]}
                        >
                          <span style={{ fontWeight: 400 }}>&nbsp;{`${_checkbox.label}`}</span>
                        </Checkbox>
                      </Col>
                    ))}

                    {/* <Col xs={12}></Col> */}
                  </Row>
                </Col>
              </Row>
            </div>
          ))}
        </div>
      </div>
    );
  };
  const renderButtonGroup = () => {
    return (
      <div className={cn(styles.btnContainer, 'text-center')} style={{ marginTop: 35 }}>
        <Button type="primary" size="large" onClick={updateData} style={{ marginRight: 15 }}>
          Save
        </Button>

        <Button type="danger" size="large" onClick={() => window.location.reload()}>
          Cancel
        </Button>
      </div>
    );
  };

  return (
    <div className={cn('container')} style={{ paddingBottom: 50 }}>
      <Spin tip="Loading" size="large" spinning={!!loading}>
        {/* <div className="row" style={{ marginTop: 20 }}>
          <div className="col-xs-12 col-md-8">
            
          </div>
        </div> */}
        <Row className="with-margin-top">
          <Col xs={24} className="with-padding-right">
            <Card bordered={false} noHovering={true}>
              <div className={cn(styles.form)}>
                <div className={styles.title} style={{ fontSize: 24, fontWeight: 'bold' }}>
                  จัดการปฏิทิน
                </div>
                {renderForm()}
                {renderButtonGroup()}
              </div>
            </Card>
          </Col>
        </Row>
      </Spin>
    </div>
  );
};

export default TeacherCalendar;
